<template>
    <cluji-card title="Fin d'année" subtitle="Terminer l'année en cours">
        <div class="text-center">
            <b-button variant="danger" class="disk-button p-0 m-2" @click="triggerEndYear">
                <font-awesome-icon icon="biohazard"/>
            </b-button>
        </div>
    </cluji-card>
</template>

<script>
    const EndYearModal = () => import('@/components/modals/EndYearModal');
    const ClujiCard    = () => import('@/components/ClujiCard');

    export default {
        name: 'WebcretariumEndYear',
        components: {ClujiCard},
        methods: {
            triggerEndYear() {
                this.$store.dispatch('modal/create', {component: EndYearModal});
            }
        }
    };
</script>

<style lang="scss" scoped>
    .disk-button {
        border-radius: 50%;
        width: 200px;
        height: 200px;
        font-size: 140px;
        line-height: 200px;
        box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.25);
        background-color: #e00000;

        &:hover {
            box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.5);
        }
    }
</style>